import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import type CustomMetricSetupFormApiMetricBuilder from 'webapp/models-custom/custom-metric-setup-form/api-metric-builder';
import type CustomMetricSetupFormSheet from 'webapp/models-custom/custom-metric-setup-form/sheet';
import type CustomQuery from 'webapp/models-custom/custom-query';

export interface Args {
	model: CustomQuery;
	form: CustomMetricSetupFormSheet | CustomMetricSetupFormApiMetricBuilder;
	stepId: string;
	isAlreadyVisited: boolean;
	origin: string;
	controlsNode: HTMLElement;
	goNext: () => void;
	goPrevious: () => void;
}

interface CustomQuerySetupWizardCommonStepCommonComponentInterface<T extends Args> {
	Args: T;
	Blocks: { default: [] }; // this is needed for yield
}

export default abstract class CustomQuerySetupWizardCommonStepCommonComponent<
	T extends Args,
> extends Component<CustomQuerySetupWizardCommonStepCommonComponentInterface<T>> {
	@service('navigation') declare navigationService: Service.Navigation;

	@tracked submitInProgress = false;

	stepTitle = '';
	stepDescription = '';
	optionNoneLabel = 'None';

	get theme() {
		return this.navigationService.theme.id;
	}

	abstract get isNextDisabled(): boolean;

	abstract get isNoneShown(): boolean;

	abstract get isNoneDisabled(): boolean;

	abstract get noneDisabledText(): string;
}
